import React from 'react';
import PropTypes from 'prop-types';
import { Table, Collapse, Icon, Tabs } from 'antd';
import styled from 'styled-components';
import { Link } from 'react-router-dom';

const Panel = Collapse.Panel;

const Wrapper = styled.div`
  h3,
  p {
    color: white;
  }

  .ant-tabs {
    color: white;
  }

  .ant-collapse p {
    color: black;
  }
`;

const TabPane = Tabs.TabPane;

class AssetMeta extends React.Component {
  render() {
    const { node, onClose, requestMountedOn } = this.props;
    const dataSource = Object.keys(node.metadata || {}).map(k => ({
      key: k,
      name: k,
      value: node.metadata[k],
      parentId: node.parentId,
    }));
    const timeseries = (node.timeseries || []).map(t => ({
      ...t,
      key: t.tagId,
    }));
    const columns = [
      {
        dataIndex: 'name',
        key: 'name',
      },
      {
        dataIndex: 'value',
        key: 'value',
        render: (text, record) => {
          if (record.name === 'ParentTag') {
            return <Link to={`/assets/${record.parentId}`}>{text}</Link>;
          } else if (record.name === 'MountedOn') {
            return <a onClick={() => requestMountedOn(text)}>{text}</a>;
          }
          return text;
        },
      },
    ];

    return (
      <Wrapper>
        <h3>
          {node.name}
          <Icon
            type="close-circle-o"
            style={{
              color: 'white',
              float: 'right',
              cursor: 'pointer',
              fontSize: '1.2rem',
            }}
            onClick={onClose}
          />
        </h3>
        <p>{node.description}</p>
        <Tabs defaultActiveKey="1">
          <TabPane tab="Details" key="1">
            <Table
              showHeader={false}
              dataSource={dataSource}
              columns={columns}
              pagination={false}
              scroll={{ y: '75vh' }}
              bordered
              style={{
                borderRadius: '5px',
                backgroundColor: 'white',
                color: 'rgba(0, 0, 0, 0.45)',
              }}
            />
          </TabPane>
          <TabPane tab="Time series" key="2">
            <Collapse accordion>
              {timeseries.length > 0 &&
                timeseries.map(a => (
                  <Panel header={a.tagId} key={a.key}>
                    <p>
                      {a.description}{' '}
                      {a.unit ? <strong>[{a.unit}]</strong> : null}
                    </p>
                  </Panel>
                ))}
            </Collapse>
            {/* <Table
              showHeader={false}
              dataSource={timeseries}
              columns={tsColumns}
              pagination={false}
              scroll={{ y: '75vh' }}
              bordered
              style={{
                borderRadius: '5px',
                backgroundColor: 'white',
                color: 'rgba(0, 0, 0, 0.45)',
              }}
              // rowSelection={rowSelection}
            /> */}
          </TabPane>
        </Tabs>
      </Wrapper>
    );
  }
}

AssetMeta.propTypes = {
  node: PropTypes.object,
  onClose: PropTypes.func.isRequired,
  requestMountedOn: PropTypes.func.isRequired,
};

AssetMeta.defaultProps = {
  node: {},
};

export default AssetMeta;



// WEBPACK FOOTER //
// ./src/components/AssetMeta/AssetMeta.js